/// Permissões de uma chave de API; os valores espelham ApiScopes no backend.
export const API_SCOPES = {
    leadsRead: 'leads.read',
    leadsCreate: 'leads.create',
    leadsUpdate: 'leads.update',
    peopleRead: 'people.read',
    peopleWrite: 'people.write',
    schedulesRead: 'schedules.read',
    schedulesWrite: 'schedules.write',
    messagesSend: 'messages.send',
    boardsRead: 'boards.read',
} as const;

export type ApiScope = typeof API_SCOPES[keyof typeof API_SCOPES];

type ScopeKey = keyof typeof API_SCOPES;

/// Como a tela agrupa as permissões; a chave de cada item também é a do texto em apiTokens.escopos.
export const SCOPE_GROUPS: { titleKey: string; scopes: ScopeKey[] }[] = [
    { titleKey: 'apiTokens.grupoLeads', scopes: ['leadsRead', 'leadsCreate', 'leadsUpdate'] },
    { titleKey: 'apiTokens.grupoPessoas', scopes: ['peopleRead', 'peopleWrite'] },
    { titleKey: 'apiTokens.grupoAgenda', scopes: ['schedulesRead', 'schedulesWrite'] },
    { titleKey: 'apiTokens.grupoQuadros', scopes: ['boardsRead'] },
    { titleKey: 'apiTokens.grupoMensagens', scopes: ['messagesSend'] },
];

/// Atalhos para os usos mais comuns, em vez de marcar um por um.
export const SCOPE_PRESETS: { labelKey: string; scopes: ApiScope[] }[] = [
    {
        // Criar lead pede o id da coluna e do status: sem ler os quadros, o formulário não monta.
        labelKey: 'apiTokens.atalhoSite',
        scopes: [API_SCOPES.leadsCreate, API_SCOPES.boardsRead],
    },
    {
        labelKey: 'apiTokens.atalhoLeitura',
        scopes: [API_SCOPES.leadsRead, API_SCOPES.peopleRead, API_SCOPES.schedulesRead, API_SCOPES.boardsRead],
    },
    {
        labelKey: 'apiTokens.atalhoTudo',
        scopes: Object.values(API_SCOPES),
    },
];

/// O texto de uma permissão pelo valor que vem da API.
export const scopeLabelKey = (scope: string) => {
    const key = (Object.keys(API_SCOPES) as ScopeKey[]).find((k) => API_SCOPES[k] === scope);

    return key ? `apiTokens.escopos.${key}` : null;
};

/// Criar ou mover lead sem ler os quadros não funciona: a chamada precisa dos ids de coluna e status.
export const needsBoards = (scopes: string[]) =>
    (scopes.includes(API_SCOPES.leadsCreate) || scopes.includes(API_SCOPES.leadsUpdate))
    && !scopes.includes(API_SCOPES.boardsRead);
